/*
 * @Description:
 * @Date: 2025-01-22 18:03:46
 */
import Config from '@/config';
import { MessageBox } from 'element-ui';
import { verify } from '../api/ajax';

/**
 * 完成了老版本e签宝认证，未完成新版本e签宝认证
 * @param {*} enterpriseAuthInfo
 * @returns
 */
export const checkV3NoSigned = async () => {
  const {
    data: {
      data: { enterpriseAuthStatus, v3EnterpriseAuthStatus, v3GrantStatus }
    }
  } = await verify.interception();
  if (
    enterpriseAuthStatus == 1 &&
    !(v3EnterpriseAuthStatus == 2 && v3GrantStatus == 2)
  ) {
    MessageBox.confirm(
      '根据2024年11月1日起实施的《电子认证服务管理办法》第十条、第十四条规定，您需要完成实名认证及授权后，方可继续办理其他业务。',
      '温馨提示',
      {
        confirmButtonText: '企业认证',
        center: true
      }
    ).then(() => {
      location.href = `${Config.sunWebUrl}/auth.html`;
    });
    throw 'error';
  }
};
